import { MENU, UI_CODE } from '@/common/resources/const'
import {
  PATH_NAME_AGREEMENT, PATH_NAME_COVER_REDIRECT,
  PATH_NAME_CUSTOMER_AGREEMENT_REDIRECT,
  PATH_NAME_EVENT_BOARD_LIST, PATH_NAME_EVENT_BOARD_LIST_REDIRECT, PATH_NAME_EVENT_BOARD_VIEW_REDIRECT,
  PATH_NAME_EVENT_DETAIL_REDIRECT,
  PATH_NAME_EVENT_LIST,
  PATH_NAME_EVENT_LIST_REDIRECT, PATH_NAME_GLOBAL,
  PATH_NAME_HOME,
  PATH_NAME_HOME_REDIRECT, PATH_NAME_LOGIN_REDIRECT, PATH_NAME_MYPOOQ_INDEX_REDIRECT, PATH_NAME_MYPOOQ_REDIRECT,
  PATH_NAME_THEME_MOVIE,
  PATH_NAME_THEME_VOD
} from '@/common/resources/router.const'

export default [
  {
    path: 'index',
    name: PATH_NAME_HOME_REDIRECT,
    redirect: () => {
      return { name: PATH_NAME_HOME, meta: { uiCode: UI_CODE.HOME, section: MENU.HOME } }
    }
  },
  { // TODO: 오픈뒤에 URL 정리 해야 함 지금 은 실서버데이터를 바꾸면 기존 서비스에서 에러가 날 수 있으나 임시로 처리
    path: 'movie/theme-contents',
    alias: 'movie/theme-contents.html',
    name: PATH_NAME_THEME_MOVIE,
    beforeEnter (to, from, next) {
      next('/list/EN' + to.query.themeid)
    }
  },
  {
    path: 'vod/theme-contents',
    alias: 'vod/theme-contents.html',
    name: PATH_NAME_THEME_VOD,
    beforeEnter (to, from, next) {
      next('/list/EN' + to.query.themeid)
    }
  },
  {
    path: 'agreement/:section',
    name: PATH_NAME_CUSTOMER_AGREEMENT_REDIRECT,
    redirect: (to) => {
      if (to.params.section === 'service') {
        return { name: PATH_NAME_AGREEMENT, query: { category: 'service' } }
      } else if (to.params.section === 'privacy') {
        return { name: PATH_NAME_AGREEMENT, query: { category: 'privacy' } }
      } else if (to.params.section === 'paid') {
        return { name: PATH_NAME_AGREEMENT, query: { category: 'payment' } }
      } else if (to.params.section === 'youth') {
        return { name: PATH_NAME_AGREEMENT, query: { category: 'youth' } }
      } else if (to.params.section === 'pooqzone') {
        return { name: PATH_NAME_AGREEMENT, query: { category: 'pooqzone' } }
      }
    }
  },
  {
    path: 'event/list',
    name: PATH_NAME_EVENT_LIST_REDIRECT,
    redirect: () => {
      return { name: PATH_NAME_EVENT_LIST, meta: { menu: 'event', type: 'event' } }
    }
  },
  {
    path: 'event/detail/:section',
    name: PATH_NAME_EVENT_DETAIL_REDIRECT,
    redirect: (to) => {
      return {
        name: 'event_view',
        query: { eventId: to.params.section, prevPage: 1 },
        meta: { menu: 'event', type: 'event' }
      }
    }
  },
  {
    path: 'event/board',
    name: PATH_NAME_EVENT_BOARD_LIST_REDIRECT,
    redirect: () => {
      return { name: PATH_NAME_EVENT_BOARD_LIST, meta: { menu: 'board', type: 'event' } }
    }
  },
  {
    path: 'event/board/:section',
    name: PATH_NAME_EVENT_BOARD_VIEW_REDIRECT,
    redirect: (to) => {
      return {
        name: 'event_board_view',
        query: { eventId: to.params.section, pageNum: 1 },
        meta: { menu: 'board', type: 'event' }
      }
    }
  },
  {
    path: 'voucher/pooqzone',
    redirect: '/voucher/wavveon'
  },
  {
    path: 'voucher/pooqzone.html',
    redirect: '/voucher/wavveon'
  },
  {
    path: 'login',
    name: PATH_NAME_LOGIN_REDIRECT,
    redirect: () => {
      return { name: 'login' }
    }
  },
  {
    path: 'clip/index.html',
    name: 'clip_redirect_html',
    redirect: () => {
      return { name: PATH_NAME_GLOBAL }
    }
  },
  {
    path: 'clip/index',
    name: 'clip_redirect',
    redirect: () => {
      return { name: PATH_NAME_GLOBAL }
    }
  },
  {
    path: 'voucher/recommend.html',
    redirect: () => {
      return '/voucher/index'
    }
  },
  {
    path: 'baseball/highlight',
    redirect: 'baseball'
  },
  {
    path: 'member',
    redirect: '/member/login.html'
  },
  {
    path: 'mypooq',
    name: PATH_NAME_MYPOOQ_INDEX_REDIRECT,
    redirect: (to) => {
      const pathList = to.fullPath.split('/')
      pathList[1] = 'my'
      return pathList.join('/')
    }
  },
  {
    path: 'mypooq/:path',
    name: PATH_NAME_MYPOOQ_REDIRECT,
    redirect: (to) => {
      const pathList = to.fullPath.split('/')
      pathList[1] = 'my'
      return pathList.join('/')
    }
  },
  {
    path: 'playy',
    redirect: () => {
      return { name: PATH_NAME_HOME }
    }
  },
  {
    path: 'cover',
    name: PATH_NAME_COVER_REDIRECT,
    redirect: () => {
      return { name: PATH_NAME_HOME }
    }
  },
  {
    path: 'bifan',
    name: 'PATH_NAME_BIFAN_X_WAVVE_REDIRECT',
    redirect: () => {
      return '/supermultisection/GN803'
    }
  }
]
